import Vue from 'vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';


let toast = function (text) {
Vue.$vux.toast.show({
width: 'auto',
type: 'text',
time: 3000,
position: 'middle',
text
})
}
let messageSelf = function (type, msg) {
Message({
type: type,
message: msg,
duration: 1500
})
}
let loading = function (text) {
Vue.$vux.loading.show({
width: 'auto',
type: 'text',
position: 'middle',
text
})
}
Vue.use(AjaxPlugin)
let isbol = true;
const CancelToken = axios.CancelToken
let sources = []  

let removeSource = (config) => {
for (let source in sources) {

if (sources[source].umet === config.url + '&' + config.method) {
sources[source].cancel("取消请求")
sources.splice(source, 1)
}
}
}

axios.defaults.retry = 0;
let ind = 0;
const Instance = axios.create({
retry: 0, // 超时后请求次数
baseURL: process.env.BASE_URL,
timeout: 1000 * 100,
headers: {
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
'X-Requested-With': "XMLHttpRequest"
}

})


Instance.interceptors.request.use(config => {
removeSource(config)
config.cancelToken = new CancelToken((c) => {

sources.push({ umet: config.url + '&' + config.method, cancel: c })
})
return config
}, (error) => {
toast('请求错误!')
return Promise.reject(error)
})


Instance.interceptors.response.use(res => {
Vue.$vux.loading.hide();
let index = res.data.resultCode;
let ua = navigator.userAgent.toLowerCase();
let isWeixin = ua.indexOf('micromessenger') != -1;
switch (index) {
case 0:
return res.data;
break;
case -2:

messageSelf("error", '没有权限！')
window.localStorage.setItem("isLogin", false);
if (isWeixin) {
router.push({ name: "WeixinLogin" })
return true;
} else {
router.push({ name: "PlatformLogin" })
return false;
}
break;
case 4:
return res.data;
break;
case 5:
return res.data;
break;
case -4:

messageSelf("error", "你的账号已在其他地方登陆，你被迫下线")
window.localStorage.setItem("isLogin", false);
if (isWeixin) {
router.push({ name: "WeixinLogin" })
return true;
} else {
router.push({ name: "PlatformLogin" })
return false;
}
break;
case -5:

messageSelf("error", "您已被取消所有管理权限，请重新登录！")
window.localStorage.setItem("isLogin", false);
if (isWeixin) {
router.push({ name: "WeixinLogin" })
return true;
} else {
router.push({ name: "PlatformLogin" })
return false;
}
break;
case 1004:
if (isbol) {
isbol = false;
MessageBox.confirm("您在该群的管理权限已被取消！", "提示", {
confirmButtonText: "确定",
cancelButtonText: "取消",
type: "warning"
}).then(() => {
router.push({ name: "Operating" })
isbol = true;
})
.catch(() => {
router.push({ name: "Operating" })
isbol = true;
});
}

break;
default:

messageSelf("warning", res.data.resultDesc)
break;
}

}, (error) => {
Vue.$vux.loading.hide();
if (error.message === "取消请求") {
toast("请勿重复请求！")
} else { toast("请求出错了！") }

return Promise.reject(error)
})

export default Instance



// WEBPACK FOOTER //
// ./src/api/resource.js